import domain from "./DomainService";
import { WARM_DASHBOARD_API_BASE } from "./apiEndpoints";

/**
 * Get the user's accountability data to display on Accountability Page.
 * This is the list of people who have been assigned to comment on this uers's link.
 *
 * Uses JWT token to identify user
 * @return {Promise}
 */
export default function AdminDashboardService() {
  const token = localStorage.getItem("token");
  const options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
  };
  return fetch(domain() + "app-metrics", options);
}

export const GetDashboardAnalytics = (userId) => {
  const options = {
    method: "POST",
    body: JSON.stringify({ userId }),
  };
  return fetch(
    `${WARM_DASHBOARD_API_BASE}/getDashboardAnalytics`,
    options
  );
};

export const GetSuggestedNextStep = (userId) => {
  const options = {
    method: "POST",
    body: JSON.stringify({ userId }),
  };
  return fetch(
    `${WARM_DASHBOARD_API_BASE}/getSuggestedNextStep`,
    options
  );
};
